import { ProductDTO } from '../../http/dtos/products/productsDTO';
import httpClient from '../../http/httpClient';

export const ProductsRepository = {
    GetProductsList: () => {
        return httpClient
            .get('/products')
            .then((response: ProductDTO[]) => response);
    },
    GetLicensedProductsList: () => {
        return httpClient
            .get('/products/licensed')
            .then((response: ProductDTO[]) => response);
    },
};
